<template>
  <div style="height: 100%;background-color: #fbfbfb">
    <div style="height: 100%;margin: 0 20px">
      <div style="height: 50px;padding-top: 20px">
<!--        <el-button type="primary" plain icon="el-icon-plus" @click="addBtn()">新增</el-button>-->
        <!--        <el-input prefix-icon="el-icon-search" placeholder="输入套餐名称查询" style="width: 250px"></el-input>-->
        <span>餐厅：</span>
        <el-select v-fixZoom v-model="restaurantid" filterable placeholder="请选择" :clearable="true" style="width: 200px">
          <el-option v-for="item in restaurants" :key="item.index" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <el-date-picker v-fixZoom v-model="weekValue" type="week" format="yyyy 第 WW 周" :picker-options="weekOptions" placeholder="选择周" @change="changeWeek"></el-date-picker>
        <el-button type="success" @click="queryDataTable">查询</el-button>
        <el-button type="primary" plain icon="el-icon-plus" @click="addBtn()">新增</el-button>
      </div>
      <div style="height: calc(100% - 80px);overflow-y: auto">
<!--  :span-method="objectSpanMethod" -->
        <el-table height="100%" :data="tableData" border highlight-current-row ref="singleTable">
          <el-table-column
            prop="weekdate"
            label="日期"
            width="120"
            align="center">
          </el-table-column>
          <el-table-column
            prop="week"
            label="星期"
            width="90"
            align="center">
          </el-table-column>
          <el-table-column
            label="提供类型"
            min-width="80"
            align="center">
            <template slot-scope="scope">
<!--              1 早餐-->
<!--              2 午餐-->
<!--              3 早餐和午餐-->
<!--              4 晚餐-->
<!--              5 早餐和晚餐-->
<!--              6 午餐和晚餐-->
<!--              7 早餐，午餐，晚餐-->
              <span v-if="scope.row.type === 1">早餐</span>
              <span v-if="scope.row.type === 2">午餐</span>
              <span v-if="scope.row.type === 4">晚餐</span>
            </template>
          </el-table-column>
          <el-table-column
            label="提供菜品、套餐"
            min-width="500"
            align="left">
            <template slot-scope="scope">
              <table border="1" style="border-collapse: collapse;border: #dedfe1;" v-if="scope.row.endArr0.length !== 0">
                <tr v-for="(item0, index0) in scope.row.endArr0" :key="index0">
                  <td><span class="st">{{ item0.name }} / {{ item0.cnt }}份</span></td>
                  <td><span class="st" v-if="item0.dish_kcal !== ''">{{ item0.dish_kcal }} kcal</span></td>
                  <td>
                    <div class="st" v-if="item0.nutrients !== ''">
                      <table border="1" style="border-collapse: collapse;border: #F5F7FA;margin: auto">
                        <tr><td style="padding: 5px 15px"><span>碳水化合物：{{item0.nutrients.CHO}}克</span></td></tr>
                        <tr><td style="padding: 5px 15px"><span>碳水化合物：{{item0.nutrients.CHO}}克</span></td></tr>
                        <tr><td style="padding: 5px 15px"><span>蛋白质：{{item0.nutrients.PRO}}克</span></td></tr>
                        <tr><td style="padding: 5px 15px"><span>脂肪：{{item0.nutrients.FAT}}克</span></td></tr>
                        <tr><td style="padding: 5px 15px"><span>糖类：{{item0.nutrients.SUG}}克</span></td></tr>
                        <tr><td style="padding: 5px"><span>膳食纤维：{{item0.nutrients.DF}}克</span></td></tr>
                      </table>
                    </div>
                  </td>
                  <td>
                    <div class="st" v-if="item0.picture"><img style="height: 100px" :src="baseUrl + 'food/image/' + item0.picture + '?token=' + token"></div>
                  </td>
                </tr>
              </table>
              <table border="1" style="border-collapse: collapse;border: #dedfe1;margin: 5px 0 0" v-if="scope.row.endArr1.length !== 0">
                <tr v-for="(item1, index1) in scope.row.endArr1" :key="index1">
                  <td><div class="st">{{ item1.dishpackagename }} / {{ item1.cnt }}份</div></td>
                  <td><div class="st" v-if="item1.dish_kcal !== ''">{{ item1.dish_kcal }} kcal</div></td>
                  <td>
                    <div class="st" v-if="item1.nutrients !== ''">
                      <table border="1" style="border-collapse: collapse;border: #F5F7FA;margin: auto">
                        <tr><td style="padding: 5px 15px"><span>碳水化合物：{{item1.nutrients.CHO}}克</span></td></tr>
                        <tr><td style="padding: 5px 15px"><span>蛋白质：{{item1.nutrients.PRO}}克</span></td></tr>
                        <tr><td style="padding: 5px 15px"><span>脂肪：{{item1.nutrients.FAT}}克</span></td></tr>
                        <tr><td style="padding: 5px 15px"><span>糖类：{{item1.nutrients.SUG}}克</span></td></tr>
                        <tr><td style="padding: 5px"><span>膳食纤维：{{item1.nutrients.DF}}克</span></td></tr>
                      </table>
                    </div>
                  </td>
                  <td>
                    <div class="st" v-if="item1.list.length !== 0">
                      <table border="1" style="border-collapse: collapse;border: #dedfe1;margin: 5px auto 0">
                        <tr v-for="(item2, index2) in item1.list" :key="index2">
                          <td><div class="st">{{ item2.name }}</div></td>
                          <td><div v-if="item2.picture" class="st"><img style="height: 100px"  :src="baseUrl + 'food/image/' + item2.picture + '?token=' + token"></div></td>
                        </tr>
                      </table>
                    </div>
                  </td>
                </tr>
              </table>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="100">
            <template slot-scope="scope">
              <i title="编辑" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editBtn(scope.row)"></i>
              <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delBtn(scope.row)"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog :visible.sync="addEditShow" v-if="addEditShow" width="800px"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <span>{{ addEditTitle }}</span>
        <div class="line-title"></div>
      </div>
      <add-edit-week-menu :addEditObj="addEditObj" v-model="addEditShow" @updateTable="updateTable"></add-edit-week-menu>
    </el-dialog>
  </div>
</template>

<script>
import {getToken} from '../../utils/auth'
import {deletedishweek, querydish, querydishpackage, queryrestaurant, querydishweek} from '../../api/yanglaoyuan'
import addEditWeekMenu from './components/addEditWeekMenu'
export default {
  name: 'weekSupply',
  components: {addEditWeekMenu},
  data () {
    return {
      token: '',
      entityId: 0,
      restaurantid: '',
      sendDate: [],
      weekValue: null,
      weekOptions: {
        firstDayOfWeek: 1
      },
      pickerOptions: {
      },
      restaurants: [], // 餐厅
      dishes: [], // 菜品
      dishpackages: [], // 套餐
      pageSize: 9999,
      currentPage: 1,
      totalCells: 0,
      tableData: [],
      addEditTitle: '',
      addEditShow: false,
      addEditObj: {
        restaurants: [], // 餐厅
        dishes: [], // 菜品
        dishpackages: [], // 套餐
        isAdd: true,
        row: ''
      },
      // 图片浏览器地址
      baseUrl: ''
    }
  },
  created () {
    // eslint-disable-next-line no-extend-native
    Date.prototype.format = this.validate.format
    let dateStr = new Date().format('yyyy-MM-dd')
    const date = new Date(dateStr)
    const weekday = date.getDay()
    const start = this.commonType.GetDateStr(-weekday + 1)
    let end = this.commonType.GetDateStr(7 - weekday)
    this.weekValue = dateStr
    this.sendDate = [start.format('yyyy-MM-dd'), end.format('yyyy-MM-dd')]
    this.baseUrl = this.commonType.getapi()
    this.token = getToken()
    this.entityId = this.$store.state.user.LoginResp.entity_id
    this.getRestaurants()
    // console.log(weekday)
    // console.log(start.format('yyyy-MM-dd'))
    // console.log(end.format('yyyy-MM-dd'))
  },
  methods: {
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      // console.log(rowIndex, columnIndex)
      if (columnIndex === 0 || columnIndex === 1) {
        if (rowIndex % 3 === 0) {
          return {
            rowspan: 3,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    // 餐厅
    getRestaurants () {
      let params = {
        size: 9999,
        page: 1
      }
      let data = {
        eid: this.entityId
      }
      queryrestaurant(params, data).then(res => {
        this.restaurants = res.data.restaurants
        this.restaurantid = res.data.restaurants.length > 0 ? res.data.restaurants[0].id : ''
        this.addEditObj.restaurants = res.data.restaurants
        this.queryDish()
      })
    },
    // 菜品
    queryDish () {
      this.tableData = []
      let params = {
        size: 9999,
        page: 1
      }
      let data = {
        eid: this.entityId
      }
      querydish(params, data).then(res => {
        let arr = []
        res.data.dishes.forEach(item => {
          item.nutrients = item.dish_nutrients !== '' ? JSON.parse(item.dish_nutrients) : ''
          arr.push(item)
        })
        this.dishes = arr
        this.addEditObj.dishes = arr
        this.queryDishPackages()
      })
    },
    // 套餐
    queryDishPackages () {
      let params = {
        size: 9999,
        page: 1
      }
      let data = {
        eid: this.entityId
      }
      querydishpackage(params, data).then(res => {
        let arr = []
        res.data.dishpackages.forEach(item => {
          item.kcal = ''
          item.dishcnts.map(val => {
            if (item.kcal === '') {
              if (val.dish_kcal !== '') {
                item.kcal = parseFloat(val.dish_kcal)
              }
            } else {
              item.kcal = item.kcal + parseFloat(val.dish_kcal)
            }
            val.nutrients = val.dish_nutrients !== '' ? JSON.parse(val.dish_nutrients) : ''
          })
          arr.push(item)
        })
        this.dishpackages = arr
        this.addEditObj.dishpackages = arr
        this.queryDataTable()
      })
    },
    changeWeek (val) {
      let startTime = new Date(val.getTime()) // 开始时间
      let endTime = new Date(val.getTime() + (24 * 60 * 60 * 1000) * 6) // 结束时间
      let timeArr = [startTime.toISOString().slice(0, 10), endTime.toISOString().slice(0, 10)]
      this.sendDate = timeArr
    },
    queryDataTable () {
      if (this.restaurantid === '') {
        return
      }
      let params = {
        size: this.pageSize,
        page: this.currentPage
      }
      if (this.sendDate.length > 0) {
        params.start = this.sendDate[0]
        params.end = this.sendDate[1]
      }
      let data = {
        eid: this.entityId,
        restaurantid: this.restaurantid
      }
      querydishweek(params, data).then(res => {
        let arr = []
        res.data.dishweeks.forEach(item => {
          let endArr0 = []
          let endArr1 = []
          let dishs = item.dishcnts
          let mealids = []
          dishs.forEach(val => {
            let aa = val
            if (val.dishpackageid === 0) {
              aa.nutrients = val.dish_nutrients !== '' ? JSON.parse(val.dish_nutrients) : ''
              endArr0.push(aa)
            } else {
              if (mealids.indexOf(val.dishpackageid) < 0) {
                mealids.push(val.dishpackageid)
              }
            }
          })
          for (let i = 0; i < mealids.length; i++) {
            let obj = {
              dishpackageid: mealids[i],
              dishpackagename: '',
              cnt: '',
              dish_kcal: '',
              nutrients: '',
              list: []
            }
            dishs.forEach(val1 => {
              let bb = val1
              if (obj.dishpackageid === val1.dishpackageid) {
                obj.dishpackagename = val1.dishpackagename
                obj.cnt = val1.cnt
                bb.nutrients = val1.dish_nutrients !== '' ? JSON.parse(val1.dish_nutrients) : ''
                if (bb.nutrients !== '') {
                  if (obj.nutrients === '') {
                    obj.nutrients = bb.nutrients
                  } else {
                    obj.nutrients.CHO = parseFloat(obj.nutrients.CHO) + parseFloat(bb.nutrients.CHO)
                    obj.nutrients.PRO = parseFloat(obj.nutrients.PRO) + parseFloat(bb.nutrients.PRO)
                    obj.nutrients.FAT = parseFloat(obj.nutrients.FAT) + parseFloat(bb.nutrients.FAT)
                    obj.nutrients.DF = parseFloat(obj.nutrients.DF) + parseFloat(bb.nutrients.DF)
                    obj.nutrients.SUG = parseFloat(obj.nutrients.SUG) + parseFloat(bb.nutrients.SUG)
                  }
                }
                if (bb.dish_kcal !== '') {
                  if (obj.dish_kcal === '') {
                    obj.dish_kcal = parseFloat(bb.dish_kcal)
                  } else {
                    obj.dish_kcal = obj.dish_kcal + parseFloat(bb.dish_kcal)
                  }
                }
                obj.list.push(bb)
              }
            })
            endArr1.push(obj)
          }
          item.endArr0 = endArr0
          item.endArr1 = endArr1
          arr.push(item)
        })
        // console.log(123, arr)
        this.tableData = arr
        this.totalCells = res.data.cnt
      })
    },
    getRestaurantName (id) {
      let name = id
      for (let i = 0; i < this.restaurants.length; i++) {
        if (id === this.restaurants[i].id) {
          name = this.restaurants[i].name
        }
      }
      return name
    },
    addBtn () {
      this.addEditTitle = '新增每周供应'
      this.addEditObj.isAdd = true
      this.addEditObj.row = ''
      this.addEditShow = true
    },
    editBtn (row) {
      this.addEditTitle = '编辑【' + row.week + '】供应'
      this.addEditObj.isAdd = false
      this.addEditObj.row = row
      this.addEditShow = true
    },
    delBtn (row) {
      this.$confirm('此操作将永久删除该供应【' + row.week + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          id: row.id
        }
        deletedishweek(data).then(res => {
          this.$notify({title: '成功', message: '成功删除供应', type: 'success', duration: 2000})
          if (this.tableData.length === 1 && this.currentPage > 1) {
            this.currentPage--
          }
          this.queryDataTable()
        })
      })
    },
    updateTable () {
      this.queryDataTable()
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.queryDataTable()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.queryDataTable()
    }
  }
}
</script>

<style scoped>
.st{
  padding: 5px 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/weekSupply.vue